document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      async itemQuantityChange(key, value) {
        if (this.locked) return;

        // Prefer explicit key (button path); fallback to current element context (input path)
        let lineItemEl =
          (key && this.itemsRoot.querySelector(`li[data-cart-item-key="${key}"]`)) ||
          (this.$el && this.$el.closest('li[data-cart-item-key]'));

        if (!lineItemEl) {
          console.error('Cart item element not found for quantity change');
          return;
        }

        const inputEl = lineItemEl.querySelector('input[type="number"]');
        if (!inputEl) {
          console.error('Quantity input not found for cart item');
          return;
        }

        // Get current cart item key
        let id = lineItemEl.getAttribute('data-cart-item-key');
        if (!id) {
          console.error('Cart item id not found for quantity change');
          return;
        }

        // Get variant ID from cart data to track item after key changes
        let variantId = null;
        try {
          const cartResponse = await fetch('/cart.js').then(r => r.json());
          const cartItem = cartResponse.items.find(item => item.key === id);
          if (cartItem) {
            variantId = cartItem.variant_id;
          }
        } catch (e) {
          console.warn('Could not fetch cart to get variant ID:', e);
        }

        const parsedValue = parseInt(!isNaN(value) ? value : inputEl.value, 10);
        const quantity = Number.isFinite(parsedValue) ? parsedValue : 0;
        const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults();

        // Provide both id (variant/cart item id) and line (1-based index) to satisfy cart/change requirements
        const lineIndex =
          Array.from(this.itemsRoot.querySelectorAll('li[data-cart-item-key]')).indexOf(
            lineItemEl
          ) + 1;

        config.body = JSON.stringify({
          id,
          line: lineIndex > 0 ? lineIndex : undefined,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then(async (data) => {
              if (data.item_count === currentCount) {
                // Quantity change had no effect -- most likely, there is no more inventory
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = theme.strings.cartAddError.replace(
                  '{{ title }}',
                  errorEl.dataset.itemTitle
                );

                errorEl.classList.remove('hidden');
              } else {
                // After quantity change, the cart item key may have changed
                // Re-fetch cart to get the updated key using variant ID
                if (variantId) {
                  try {
                    const updatedCart = await fetch('/cart.js').then(r => r.json());
                    const updatedItem = updatedCart.items.find(item => item.variant_id === variantId);
                    if (updatedItem && updatedItem.key !== id) {
                      // Update the DOM element with the new key
                      lineItemEl.setAttribute('data-cart-item-key', updatedItem.key);
                      id = updatedItem.key;
                    }
                  } catch (e) {
                    console.warn('Could not update cart item key:', e);
                  }
                }

                // Keep local state in sync until the fresh markup morphs in
                inputEl.dataset.lastValue = quantity;
                inputEl.value = quantity;

                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );

                // Refresh UpCart drawer after quantity change
                if (window.upcartRefreshCart) {
                  window.upcartRefreshCart();
                }
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        // Prevent button clicks while a quantity change is in progress
        if (this.locked) return;

        const lineItemEl = el.closest('li[data-cart-item-key]');
        if (!lineItemEl) {
          console.error('Line item element not found');
          return;
        }

        const inputEl = lineItemEl.querySelector('input[type="number"]');
        if (!inputEl) {
          console.error('Input element not found');
          return;
        }

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);
        let newValue = Number.isFinite(lastValue) ? lastValue : 0;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        // Get current key from the element (may have been updated after previous change)
        const currentKey = lineItemEl.getAttribute('data-cart-item-key');
        
        // Update input for immediate UI feedback and invoke change handler directly
        inputEl.value = newValue;
        this.itemQuantityChange(currentKey, newValue);
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
